import type { SVGProps } from 'react';

const SvgTextBold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.92 17.9H8.94c-.39 0-.72-.13-.98-.4-.26-.26-.4-.59-.4-.98V7.28c0-.38.14-.72.4-.98s.59-.4.98-.4h4.03c1.13 0 1.99.28 2.56.83.58.56.88 1.37.88 2.42 0 .58-.15 1.09-.43 1.54-.13.21-.3.39-.5.56.43.26.79.61 1.07 1.06.3.47.45 1.08.45 1.79 0 .76-.13 1.41-.39 1.91-.26.51-.61.91-1.04 1.19-.41.27-.86.46-1.34.56-.45.1-.89.14-1.32.14zm0-2.64c.39 0 .69-.09.9-.29.2-.18.3-.47.3-.88 0-.47-.1-.68-.19-.77a.85.85 0 0 0-.47-.28c-.24-.05-.46-.07-.66-.07h-2.37v2.29zm-2.48-4.98h2.29a.9.9 0 0 0 .58-.21c.1-.08.22-.22.22-.57s-.07-.58-.21-.7c-.15-.14-.36-.21-.64-.21h-2.24v1.7z"
    />
  </svg>
);
export default SvgTextBold;
